"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EpubView;
var _react = _interopRequireWildcard(require("react"));
var _reactReader = require("react-reader");
var _core = require("@material-ui/core");
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _reactDetectOffline = require("react-detect-offline");
var _utils = require("../../utils");
var _lab = require("@material-ui/lab");
var _contexts = require("../../contexts");
var _NotePopover = _interopRequireDefault(require("../NotePopover"));
var _Footer = _interopRequireDefault(require("./Footer"));
var _LoadingView = _interopRequireDefault(require("./LoadingView"));
var _services = require("../../services");
var _styles = require("./styles");
var _themes = require("../../themes");
require("./styles.css");
var _CopyrightDialog = _interopRequireDefault(require("../CopyrightDialog"));
var _CopyTextDialog = _interopRequireDefault(require("../CopyTextDialog"));
var _CopyrightLimitDialog = _interopRequireDefault(require("../CopyrightLimitDialog"));
var _book = require("../../constants/book");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable */ // External Libraries
// Contexts
// Components
// Services
// Styles
function EpubView() {
  var {
    backgroundStyle,
    fontButton,
    setBackgroundStyle,
    setFontButton,
    setColumnType
  } = (0, _react.useContext)(_contexts.ReaderPreferencesContext);
  var [initialPage, setInitialPage] = (0, _react.useState)(0);
  var isDesktopView = (0, _core.useMediaQuery)('(min-width:769px)');
  var classes = (0, _styles.useStyles)();
  var alertClasses = (0, _styles.alertStyles)();
  var {
    uuid,
    epubFile,
    setRendition,
    setCurrentLocation,
    setCurrentEndLocation,
    setTotalLocation,
    setCurrentPercentage,
    bookTitle,
    cfi,
    setCfi,
    setChapters,
    userId,
    applicationToken,
    sessionToken,
    setOfflineMessage,
    showingOfflineMessage,
    setAppOffline,
    setEpubFile,
    setLoadingLocations,
    loadingLocations,
    rendition,
    jumpToPage,
    setOnlineMessage,
    showingOnlineMessage
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var {
    setBookmarks
  } = (0, _react.useContext)(_contexts.BookmarksContext);
  var {
    setHighlights,
    selectTextRange,
    setHighlightsCallback,
    repaintHighlight
  } = (0, _react.useContext)(_contexts.HighlightsContext);
  var {
    snackBar
  } = (0, _react.useContext)(_contexts.SideBarContext);
  var appToken = (0, _utils.appTokenCase)(window.location.origin);
  var trackService = (0, _services.TrackingsService)(appToken, sessionToken);
  (0, _react.useEffect)(() => {
    if (loadingLocations) return;
    jumpToPage(initialPage);
    updateCurrentPage(initialPage);
  }, [loadingLocations]);
  (0, _react.useEffect)(() => {
    var syncLastPage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* () {
        try {
          var service = (0, _services.PagesService)(applicationToken, sessionToken);
          var response = yield service.getLastPage(uuid, userId);
          if (!response.ok) {
            var error = yield response.json();
            throw error;
          }
          var result = yield response.json();
          var currentPage = result.data.page;
          setInitialPage(currentPage);
        } catch (error) {
          console.error(error);
        }
      });
      return function syncLastPage() {
        return _ref.apply(this, arguments);
      };
    }();
    syncLastPage();
  }, []);
  (0, _react.useEffect)(() => {
    function fetchEpub() {
      return _fetchEpub.apply(this, arguments);
    }
    function _fetchEpub() {
      _fetchEpub = _asyncToGenerator(function* () {
        try {
          var response = yield (0, _services.EpubService)(applicationToken, sessionToken).getEpubFile(uuid);
          if (!response.ok) {
            var errors = yield response.json();
            throw errors;
          }
          var file = yield response.blob();
          setEpubFile(file);
        } catch (err) {
          console.error(err);
        }
      });
      return _fetchEpub.apply(this, arguments);
    }
    fetchEpub();
  }, [applicationToken, uuid, sessionToken, setEpubFile]);
  var syncUserHighlights = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (rend) {
      try {
        var service = (0, _services.HighlightsService)(applicationToken, sessionToken);
        var response = yield service.listUserHighlights(uuid, userId);
        if (!response.ok) {
          var error = yield response.json();
          throw error;
        }
        var result = yield response.json();
        var parsedHighlights = result.data.map(highlight => ({
          id: highlight.id,
          annotation: highlight.annotation,
          textReference: highlight.text_reference,
          textHighlighted: highlight.text_highlighted,
          color: highlight.color
        }));
        setHighlights(parsedHighlights);
        parsedHighlights.forEach(highlight => {
          selectTextRange(rend, highlight.textReference, highlight.color);
        });
      } catch (error) {
        console.error(error);
        console.log('Não foi possível carregar os destaques.');
      }
    });
    return function syncUserHighlights(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var syncUserPreferences = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* (rend) {
      try {
        var service = (0, _services.ReaderPreferencesService)(applicationToken, sessionToken);
        var response = yield service.getUserPreferences(userId);
        if (!response.ok) {
          var error = yield response.json();
          throw error;
        }
        var result = yield response.json();
        var {
          settings
        } = result.data;
        setBackgroundStyle(settings.background_style);
        setColumnType(settings.columns);
        setFontButton({
          fontSize: settings.font_size,
          fontPercentageValue: settings.font_size * 5
        });
        rend.themes.fontSize("".concat(settings.font_size, "px"));
        rend.themes.select(settings.background_style);
        if (settings.columns === 'one') {
          rend.spread('none');
          rend.resize(680);
        } else {
          rend.spread('auto');
          rend.resize(1900);
        }
      } catch (error) {
        console.error(error);
        console.log('Não foi possível carregar as preferências do usuário');
        rend.spread(_themes.DEFAULT_PREFERENCES.columns);
        rend.themes.fontSize("".concat(_themes.DEFAULT_PREFERENCES.fontSize, "px"));
      }
    });
    return function syncUserPreferences(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var syncUserBookmarks = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(function* () {
      try {
        var service = (0, _services.BookmarksService)(applicationToken, sessionToken);
        var response = yield service.listUserBookmarks(uuid, userId);
        if (!response.ok) {
          var error = yield response.json();
          throw error;
        }
        var result = yield response.json();
        var parsedBookmarks = result.data.map(bookmark => ({
          id: bookmark.id,
          cfi: bookmark.page_reference,
          chapterName: bookmark.chapter_name,
          summary: bookmark.summary
        }));
        setBookmarks(parsedBookmarks);
      } catch (error) {
        console.error(error);
        console.log('Não foi possível carregar as anotações do usuário.');
      }
    });
    return function syncUserBookmarks() {
      return _ref4.apply(this, arguments);
    };
  }();
  var generateLocations = rend => {
    var {
      book
    } = rend;
    book.ready.then(() => {
      var key = "".concat(book.key(), "-locations");
      var stored = localStorage.getItem(key);
      setLoadingLocations(true);
      if (stored) {
        return book.locations.load(stored);
      }

      // Or generate the locations on the fly
      // Can pass an option number of chars to break sections by
      // default is 150 chars
      return book.locations.generate(_book.CHARS_PER_PAGE);
    }).then(locations => {
      // Wait for book to be rendered to get current page - error generated by book.locations.load - book.locations.generate wait correctly
      setTimeout(() => {
        var loadLocation = () => {
          if (rend !== null && rend !== void 0 && rend.location) {
            var currentLocation = rend.currentLocation();
            var percent = book.locations.percentageFromCfi(currentLocation.start.cfi);
            var percentage = Math.floor(percent * 100);
            setCurrentLocation(currentLocation.start.location);
            setCurrentEndLocation(currentLocation.end.location);
            setTotalLocation(locations.length);
            setCurrentPercentage(percentage);
            setLoadingLocations(false);
          } else {
            setTimeout(loadLocation, 250);
          }
        };
        loadLocation();
      }, 2000);
      rend.on('relocated', location => {
        if (location.atEnd) {
          setCurrentLocation(locations.length);
          setCurrentEndLocation(locations.length);
          setTotalLocation(locations.length);
          setCurrentPercentage(100);
        } else {
          var percent = book.locations.percentageFromCfi(location.start.cfi);
          var percentage = Math.floor(percent * 100);
          setCurrentLocation(location.start.location);
          setCurrentEndLocation(location.end.location);
          setTotalLocation(locations.length);
          setCurrentPercentage(percentage);
        }
      });
      localStorage.setItem("".concat(book.key(), "-locations"), book.locations.save());
    }).catch(error => console.error(error));
  };
  var updateCurrentPage = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(function* (epubCfi) {
      try {
        var service = (0, _services.PagesService)(applicationToken, sessionToken);
        var response = yield service.updateCurrentPage(uuid, userId, {
          page: epubCfi
        });
        if (!response.ok) {
          var error = yield response.json();
          throw error;
        }
      } catch (error) {
        console.error(error);
      }
    });
    return function updateCurrentPage(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
  var trackingPageView = () => {
    trackService.trackPageView({
      uuid,
      titleCover: bookTitle,
      sessionToken,
      fontSize: fontButton.fontPercentageValue,
      currentPage: rendition.currentLocation().start.location
    });
  };
  var disableRightClick = rend => {
    rend.on('rendered', (_, reader) => reader.document.documentElement.addEventListener('contextmenu', event => event.preventDefault()));
  };
  var createHighlightCallback = rend => {
    rend.on('rendered', (_, reader) => setHighlightsCallback(rend, reader));
  };
  var onResize = rend => {
    if ((0, _utils.getMobileOperatingSystem)() !== 'Android') return;
    var location;
    var justResized = false;
    var correcting = false;
    rend.on('relocated', () => {
      if (!justResized) {
        if (!correcting) {
          location = rend.location.end.cfi;
        } else {
          correcting = false;
        }
      } else {
        setTimeout(() => {
          justResized = false;
          correcting = true;
          rend.display(location);
        }, 500);
      }
    });
    rend.on('resized', () => {
      justResized = true;
    });
  };

  // It fixes "No Section Found" for some books
  var getSpinePatching = rend => {
    var getSpineDefault = rend.book.spine.get.bind(rend.book.spine);
    rend.book.spine.get = function (target) {
      return getSpineDefault(target) || this.spineItems.find(item => item.idref.includes(target));
    };
  };

  // If next does not work go to next Section - Fix for section with linear = false
  var onNextPage = rend => {
    var nextDefault = rend.next.bind(rend);
    rend.next = /*#__PURE__*/_asyncToGenerator(function* () {
      var prevCfi = this.currentLocation().start.cfi;
      var response = yield nextDefault();
      var newCfi = this.currentLocation().start.cfi;
      var nextIndex = this.currentLocation().start.index + 1;
      var maxIndex = this.book.spine.length - 1;
      if (prevCfi !== newCfi || nextIndex >= maxIndex) return response;
      return this.display(nextIndex);
    });
  };

  // If prev does not work go to prev Section - Fix for section with linear = false
  var onPreviousPage = rend => {
    var prevDefault = rend.prev.bind(rend);
    rend.prev = /*#__PURE__*/_asyncToGenerator(function* () {
      var prevCfi = this.currentLocation().start.cfi;
      var response = yield prevDefault();
      var newCfi = this.currentLocation().start.cfi;
      var prevIndex = this.currentLocation().start.index - 1;
      if (prevCfi !== newCfi || prevIndex < 0) return response;
      return this.display(prevIndex);
    });
  };
  var onRenditionReady = rend => {
    if (rend) {
      getSpinePatching(rend);
      onNextPage(rend);
      onPreviousPage(rend);
      setRendition(rend);
      generateLocations(rend);
      syncUserPreferences(rend).then(() => syncUserHighlights(rend)).catch(error => console.error(error));
      syncUserBookmarks();
      disableRightClick(rend);
      createHighlightCallback(rend);
      onResize(rend);
    }
  };
  if (!epubFile) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.readerContainer
    }, /*#__PURE__*/_react.default.createElement(_reactReader.ReactReader, {
      showToc: false,
      styles: (0, _styles.reactReaderStyles)(backgroundStyle, isDesktopView, epubFile),
      epubViewStyles: _styles.epubViewStyles,
      loadingView: /*#__PURE__*/_react.default.createElement(_LoadingView.default, null)
    }), /*#__PURE__*/_react.default.createElement(_core.Hidden, {
      xsDown: true
    }, /*#__PURE__*/_react.default.createElement(_Footer.default, null))));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactDetectOffline.Detector, {
    polling: {
      url: 'https://ipv4.icanhazip.com'
    },
    onChange: isOnline => {
      if (isOnline) {
        setOnlineMessage(true);
        setOfflineMessage(false);
        setAppOffline(false);
        localStorage.removeItem('isAppOffline');
      } else {
        setOnlineMessage(false);
        setOfflineMessage(true);
        setAppOffline(true);
        localStorage.setItem('isAppOffline', true);
      }
    },
    render: _ref8 => {
      var {
        online
      } = _ref8;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !online && showingOfflineMessage && /*#__PURE__*/_react.default.createElement(_lab.Alert, {
        classes: alertClasses,
        severity: "error"
      }, "Voc\xEA est\xE1 sem internet no momento. Continue sua leitura tranquilamente, apenas n\xE3o recarregue ou feche o navegador."), /*#__PURE__*/_react.default.createElement(_saraivaUi.Snackbar, {
        classes: _styles.snackBarStyles,
        show: online && showingOnlineMessage,
        severity: "success",
        autoHideDuration: 5000,
        handleClose: () => setOnlineMessage(false)
      }, "Eba! Sua internet est\xE1 dispon\xEDvel novamente."), snackBar && isDesktopView && /*#__PURE__*/_react.default.createElement("div", {
        className: classes.snackBar
      }, /*#__PURE__*/_react.default.createElement(_saraivaUi.Snackbar, {
        severity: "success",
        noClose: true,
        show: snackBar
      }, "Refer\xEAncia bibliogr\xE1fica copiada para \xE1rea de transfer\xEAncia.")));
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.readerContainer
  }, /*#__PURE__*/_react.default.createElement(_reactReader.ReactReader, {
    url: epubFile,
    location: cfi,
    locationChanged: epubCfi => {
      setCfi(epubCfi);
      updateCurrentPage(epubCfi);
      trackingPageView();
      repaintHighlight(rendition);
    },
    getRendition: onRenditionReady,
    tocChanged: setChapters,
    showToc: false,
    styles: (0, _styles.reactReaderStyles)(backgroundStyle, isDesktopView, epubFile),
    epubViewStyles: _styles.epubViewStyles,
    loadingView: /*#__PURE__*/_react.default.createElement(_LoadingView.default, null)
  }), /*#__PURE__*/_react.default.createElement(_NotePopover.default, null), /*#__PURE__*/_react.default.createElement(_CopyrightDialog.default, null), /*#__PURE__*/_react.default.createElement(_CopyTextDialog.default, null), /*#__PURE__*/_react.default.createElement(_CopyrightLimitDialog.default, null), /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement(_Footer.default, null)))));
}